import React, { useEffect } from "react";
import {
  Paper,
  Typography,
  CircularProgress,
  Divider,
} from "@material-ui/core/";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import SyntaxHighlighter from "react-syntax-highlighter";
import remarkGfm from "remark-gfm";
import emoji from "remark-emoji";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
// import { stackoverflowDark } from "react-syntax-highlighter/dist/esm/styles/hljs";

import CommentSection from "./CommentSection";
import { getPost, getPostsBySearch } from "../../actions/posts";
import useStyles from "./styles";

const PostDetails = () => {
  const { post, posts, isLoading } = useSelector((state) => state.posts);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getPost(id));
  }, [id]);

  useEffect(() => {
    if (post) {
      dispatch(
        getPostsBySearch({ search: "none", tags: post?.tags.join(",") })
      );
    }
  }, [post]);

  if (!post) return null;

  const openPost = (_id) => navigate(`/posts/${_id}`);

  if (isLoading) {
    return (
      <Paper elevation={6} className={classes.loadingPaper}>
        <CircularProgress size="7em" />
      </Paper>
    );
  }

  const recommendedPosts = posts.filter(({ _id }) => _id !== post._id);
  // console.log(post.message);

  // trim the text message to have more control over the card size.
  const trimedPostMessage = (text) => {
    let trimedMessage;
    if (text) {
      if (text.length > 75) {
        trimedMessage = `${text.substring(0, 75)}...`;
      } else {
        trimedMessage = text;
      }
    }
    return trimedMessage || "";
  };

  return (
    <Paper style={{ padding: "20px", borderRadius: "15px" }} elevation={6}>
      <div className={classes.card}>
        <div className={classes.section}>
          <Typography variant="h4" component="h2">
            {post.title}
          </Typography>
          <Typography
            gutterBottom
            variant="h6"
            color="textSecondary"
            component="h2"
          >
            {post.tags.map((tag) => `#${tag} `)}
          </Typography>
          {/* <Typography gutterBottom variant="body1"> */}
          {/* <ReactMarkdown 
              children={post.message}
              components={{
                code: SyntaxModifier
              }} */}
          {/* /> */}
          {/* </Typography> */}

          <ReactMarkdown
            children={post.message}
            components={{
              code({ node, inline, className, children, ...props }) {
                const match = /language-(\w+)/.exec(className || "");
                return !inline && match ? (
                  <SyntaxHighlighter
                    children={String(children).replace(/\n$/, "")}
                    style={atomOneDark}
                    language={match[1]}
                    PreTag="div"
                    {...props}
                  />
                ) : (
                  <code className={className} {...props}>
                    {children}
                  </code>
                );
              },
            }}
            remarkPlugins={[
              remarkGfm,
              [
                emoji,
                {
                  padSpaceAfter: false,
                  emoticon: true,
                },
              ],
            ]}
          />

          <Typography variant="h6">Created by: {post.name}</Typography>
          <Typography variant="body1">
            {moment(post.createdAt).fromNow()}
          </Typography>
          {/* <Divider style={{ margin: '20px 0' }} />
          <Typography variant="body1"><strong>Realtime Chat - coming soon!</strong></Typography> */}
          <Divider style={{ margin: "20px 0" }} />
          {/* Comment section */}
          {/* <Typography variant="body1"><strong>Comments - coming soon!</strong></Typography> */}
          <CommentSection post={post} />

          <Divider style={{ margin: "20px 0" }} />
        </div>
        <div className={classes.imageSection}>
          <img
            className={classes.media}
            src={
              post.selectedFile ||
              "https://user-images.githubusercontent.com/194400/49531010-48dad180-f8b1-11e8-8d89-1e61320e1d82.png"
            }
            alt={post.title}
          />
        </div>
      </div>
      {!!recommendedPosts.length && (
        <div className={classes.section}>
          <Typography gutterBottom variant="h5">
            You might also like:
          </Typography>
          <Divider />
          <div className={classes.recommendedPosts}>
            {recommendedPosts.map(
              ({ title, name, message, likes, tags, selectedFile, _id }) => (
                <div
                  className={classes.singlePost}
                  onClick={() => openPost(_id)}
                  key={_id}
                >
                  <img
                    className={classes.postImg}
                    src={selectedFile}
                    width="200px"
                    alt={title}
                  />
                  <Typography gutterBottom variant="h6">
                    {title}
                  </Typography>
                  <Typography gutterBottom variant="subtitle2">
                    {name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {tags.map((tag) => `#${tag} `)}
                  </Typography>
                  {/* <ReactMarkdown children={trimedPostMessage(message)} remarkPlugins={[remarkGfm]} /> */}
                  {/* <Typography gutterBottom variant="subtitle2">{}</Typography> */}
                  <Typography gutterBottom variant="subtitle1">
                    Likes: {likes.length}
                  </Typography>
                </div>
              )
            )}
          </div>
        </div>
      )}
    </Paper>
  );
};

export default PostDetails;
